import Vue from 'vue'
import router from '../../router'
import httpManager from "../../util/common"
import { initGlobalState } from 'qiankun'

const actions = initGlobalState({})

Vue.config.productionTip = false
// Vue.component('top-navbar', { /* ... */ })
let vm = {
  delimiters: ['{', '}'],
  name: 'top-navbar',
  router,
  data: () => {
    return {
      active_index: 0,
      path: null,
      nav_list: null,
      user_account: null
    }
  },
  mounted () {
    this.getStorage()
  },
  computed: {
    showMask() {
      return this.$store.getters["limits/isShowMask"]
    },
    top_nav_list () {
      this.nav_list = [
        {path: '/home', label: this.$t('topNavBar.homePage')},
        {
          path: '/esgindustry',
          label: this.$t('topNavBar.company_esg'),
          subs: [
            {path: '/esgindustry', label: this.$t('topNavBar.esgIndustryRating')},
            {path: '/esg', label: this.$t('topNavBar.esgHome')},
            {path: '/eventhome', label: this.$t('topNavBar.ESGEventFilter')},
            {path: '/esgpublicsentiment', label: this.$t('topNavBar.ESGPublicSentiment')},
          ]
        },
        {
          path: '/fundesgindicators', label: this.$t('topNavBar.fund_esg'),
          subs: [
            {path: '/fundesgindicators', label: this.$t('topNavBar.fund_esg_indicators')},
            {path: '/fundesgrating', label: this.$t('topNavBar.fund_esg_rating')}
          ]
        },
        { 
          path: '/industrialChainFilter', label: this.$t('topNavBar.industry_chain'),
          subs: [
            {path: '/industrialChainFilter', label: this.$t('topNavBar.industrial_chain_filter')},
            {path: '/productFilter', label: this.$t('topNavBar.product_filter')},
            {path: '/supplychain', label: this.$t('topNavBar.scHome')},
            {path: '/SupplyChainAnnouncement', label: this.$t('topNavBar.SupplyChainAnnouncement')},
        ],
          sub_subs: [
            {
              label: this.$t('topNavBar.indusrtry_chain_map'),
              sub_subs_items:[
                {path: '/newenergy', label: this.$t('topNavBar.newEnergy')},
                {path: '/driverless', label: this.$t('topNavBar.driverless')},
                {path: '/fiveg', label: this.$t('topNavBar.fiveg')}
              ]
            }
        ]
        },
        {path: '/carbon', label: this.$t('topNavBar.climate'),
          subs: [
            {path: '/carbon', label: this.$t('topNavBar.carbon_info')}
            // {path: '/pollutionhome', label: this.$t('topNavBar.pollutionInfo')}
          ]
        },
        {path: '/similaritysearch', label: this.$t('topNavBar.patent'),
          subs: [
            {path: '/similaritysearch', label: this.$t('topNavBar.similarity_search')},
            {path: '/techniquefieldsearch', label: this.$t('topNavBar.technique_field_search')}
          ]
        },
        {
          path: '/esgperformreportdownload', label: this.$t('topNavBar.esg_analytics'),
          subs: [
            {path: '/esgperformreportdownload', label: this.$t('esg.company_esg_report')},
            {path: '/comparehome', label: this.$t('topNavBar.ESGCompareTool')},
            {path: '/esgfilter', label: this.$t('topNavBar.ESGFilter')},
            {path: '/sfdrupload', label: this.$t('topNavBar.sfdr')},
            {path: '/insuranceesgupload', label: this.$t('topNavBar.insurance_esg')},
            {path: '/insuranceesgranking', label: this.$t('topNavBar.insurance_esg_ranking')}
          ]
        },
        {
          path:'/esgreport',label:this.$t('topNavBar.esg_report'),
          subs:[
            {path:'/esgreport',label:this.$t('topNavBar.esg_report')},
          ]
        },
        {
          path:'/reportranking',label:this.$t('topNavBar.research_report'),
          subs:[
            {path:'/reportranking',label:this.$t('topNavBar.report_ranking')},
            {path:'/researchreport',label:this.$t('topNavBar.topic_search')},
          ]
        }
      ]
      this.path=this.$route.path
      for(let index in this.nav_list){
        let nav = this.nav_list[index]
        if(this.path.indexOf(nav.path) != -1) {
          this.changeActive(index)
        }
        if(nav.subs){
          for(let i in nav.subs){
            let nav_s = nav.subs[i]
            if(this.path.indexOf(nav_s.path) != -1) {
              this.changeActive(index)
            }
          }
          if (nav.sub_subs_items) {
            for (let i in nav.sub_subs_items) {
              let nav_s_sub = nav.sub_subs_items[i]
              if (this.path.indexOf(nav_s_sub) != -1) {
                this.changeActive(index)
              }
            }
          }
        }
      }
      return this.nav_list
    }
  },
  methods: {
    changeActive (index) {
      this.active_index = index
    },
    logout(){
      httpManager('logout')
        .then(response => {
          let agentCode = sessionStorage.getItem('agentcode')
          let loginPath = '/login'
          if(agentCode == 'gzjrfz'){
            loginPath = '/gzjrfzlogin'
          }
          const {
            href
          } = this.$router.resolve({path: loginPath})
          sessionStorage.removeItem('username')
          sessionStorage.removeItem('agentcode')
          window.open(href, '_self')
        })
        .catch(error => {
          console.log(error)
        })
    },
    changeLocale () {
      // 当前语言发生变化时，将当前语言存入cookie，同时更新备选语言
      if (this.$i18n.locale === 'zh') {
        this.$i18n.locale = 'en'
        this.$store.dispatch('setLocale', 'en')
        this.another_locale = '中文'
        actions.setGlobalState({ locale: 'en' })
      } else {
        this.$i18n.locale = 'zh'
        this.$store.dispatch('setLocale', 'zh')
        this.another_locale = 'En'
        actions.setGlobalState({ locale: 'zh' })
      }
    },
    getStorage () {
      this.user_account = sessionStorage.getItem('username')
    }
  },
  watch: {
    $route: {
      handler: function (val,oldVal) {
        this.user_account = sessionStorage.getItem('username')
      },
      deep: true
    }
  }
}

export default vm



// WEBPACK FOOTER //
// ./src/home/js/top_navbar.js